// Detecção de idioma a partir do header accept-language, compartilhada entre o
// middleware de rota (middleware/lang-redirect.ts) e o server middleware de
// URLs legadas (server/middleware/lang-prefix-redirect.ts). Ambos devem seguir
// exatamente a MESMA regra — por isso mora aqui, na camada shared.

// Extrai o idioma de MAIOR prioridade do header accept-language, respeitando os
// pesos q= (ex.: "en-US,en;q=0.9,pt-BR;q=0.8,pt;q=0.7" → "en-us"). Em empate de
// peso, o primeiro listado vence (mais à esquerda = maior prioridade, conforme
// convenção do header). Retorna o idioma primário do navegador ou "" se ausente.
export function primaryBrowserLang(acceptLanguage: string): string {
  const top = acceptLanguage
    .split(",")
    .map((part, index) => {
      const [tag, ...params] = part.trim().split(";");
      const qParam = params.find((p) => p.trim().startsWith("q="));
      const q = qParam ? Number.parseFloat(qParam.slice(qParam.indexOf("=") + 1)) : 1;
      return { tag: tag.trim().toLowerCase(), q: Number.isNaN(q) ? 0 : q, index };
    })
    .filter((item) => item.tag && item.tag !== "*")
    .sort((a, b) => b.q - a.q || a.index - b.index)[0];

  return top?.tag ?? "";
}

// Resolve o prefixo de idioma do site (pt-br | en) a partir do accept-language.
// Sem idioma primário legível (header ausente/só "*", ex.: facebookexternalhit)
// → default pt-br, pois o site é majoritariamente brasileiro.
export function resolveSiteLang(acceptLanguage: string): "pt-br" | "en" {
  const primary = primaryBrowserLang(acceptLanguage);
  return !primary || primary.startsWith("pt") ? "pt-br" : "en";
}
